import { FETCH_FLIRTS, FLIRT_SKIP } from './types'
import { objectReducer, mergeArrays } from 'utils'

const initialState = {
  index: 0,
  accounts: [],
}

const accounts = objectReducer(FETCH_FLIRTS, initialState, {
  success: ({ accounts = [], success, location }, state) => ({
    error: !success && location,
    accounts: mergeArrays([state.accounts, accounts], e => e.mediaId),
  }),
  extra: (state, { type }) => {
    if (/FLIRT_(DIS)?LIKE_SUCCESS/.test(type)) {
      return { ...state, index: state.index + 1, skipped: false }
    }
    if (type == FLIRT_SKIP) {
      return { ...state, skipped: true }
    }
    return state
  },
})

export default accounts
